/* eslint-disable no-loop-func */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import AbortController from "abort-controller"
// import ReactDragListView from "react-drag-listview";
import { useKeycloak } from '@react-keycloak/web'
import { useSelector, useDispatch } from 'react-redux'
import { setSavedProgrammiTab } from '../redux/actions/index'

import './ProgramPage.scss'
import '../components/MainBody.scss'
import Header from '../components/Header'
import RightBar from '../components/RightBar'
import Footer from '../components/Footer'
// import ToolKit from '../components/ToolKit.js'
// import PopUp from '../components/PopUp'
import LeftBar from '../components/LeftBar';
import MainBody from '../components/MainBody';

// import { ReactComponent as RightwardIcon } from '../assets/svg/leftBar/rightward.svg'
// import { ReactComponent as SaveIcon } from '../assets/svg/body/material-save.svg'


function ProgramPage() {
  // var tableCount1 = 0
  // var tableCount2 = 0
  const constData = {
    countPerPage : 20,
    countPerFilter : 5,
    defaultHeadings : [
      [
        'Utilizzatore',
        'Canale',
        'Produzione',
        'ID Produzione',
        'Codice Produzione',
        'Edizione',
        'Genere Produzione',
        'Produttore',
        'Data Inizio',
        'Data Fine',
      ],
      [
        'Utilizzatore',
        'Canale',
        'Produzione',
        'ID Produzione',
        'Codice Produzione',
        'Genere Produzione',
        'Master',
        'Id Master',
        'Codice Master',
        'Clone',
        'Stato',
        'Data Inizio',
        'Data Fine',
      ]
    ],
    defaultDetailHeadings : [
      [
        'Master',
        'Id Master',
        'Cod Master',
        'Clone',
        'Stato',
        'Data Inizio',
        'Data Fine'
      ],
      [
        'ID Detail',
        'Detail',
        'Data Inizio',
        'Data Fine'
      ]
    ],
    defaultSearchValue: [
      {
        name: 'Utilizzatore',
        value: null,
      },
      {
        name: 'Canale',
        value: null,
      },
      {
        name: 'Produzione',
        value: null,
      },
      {
        name: 'ID Produzione',
        value: [null],
      },
      {
        name: 'Codice Produzione',
        value: [null],
      },
      {
        name: 'Genere Produzione',
        value: null,
      },
      {
        name: 'Escludi Cloni',
        value: true,
      },
      {
        name: 'Escludi Film',
        value: false,
      },
      {
        name: 'Solo Film',
        value: true,
      },
      {
        name: 'Da data',
        value: null,
      },
      {
        name: 'A data',
        value: null,
      },
      {
        name: 'Master',
        value: null,
      },
      {
        name: 'ID Master',
        value: null,
      },
      {
        name: 'Codice Master',
        value: null,
      },
      {
        name: 'Stato Master',
        value: null,
      },
    ],
    defaultSearchObject : {
      canale: null,
      codProduzione: [],
      dtFine: null,
      dtInizio: null,
      flagEscludiCloni: true,
      flagEscludiFilm: false,
      flagSoloFilm: true,
      idGenereSiae: null,
      idProduzione: [],
      nomeProduzione: null,
      utilizzatore: null,
    },
    defaultFilterObject : [
      { title: "Canale", data: [], limitCount: 5 },
      { title: "Produzione", data: [], limitCount: 5 },
      { title: "Genere Produzione", data: [], limitCount: 5 }
    ]
  }
  const { keycloak } = useKeycloak()
  const dispatch = useDispatch()
  const exitRequestController = new AbortController()

  var myHeaders = new Headers()
  myHeaders.append('Accept', 'application/json')
  myHeaders.append('Content-Type', 'application/json')
  myHeaders.append('Authorization', 'Bearer ' + keycloak.token)
  const getReqOptions = {
    method: 'GET',
    headers: myHeaders,
    redirect: 'follow',
    signal: exitRequestController.signal,
  }
  const postReqOptions = {
    method: 'POST',
    headers: myHeaders,
    redirect: 'follow',
    signal: exitRequestController.signal,
  }

  const baseUrl = useSelector((state) => state.baseUrl)
  const passFlag = useSelector((state) => state.loginPage.passFlag)
  const savedProgrammiTab = useSelector((state) => state.savedProgrammiTab)

  const setSavedProgrammiTaB = (obj, index) => { dispatch(setSavedProgrammiTab(obj, index)) }

  const [topTabId, setTopTabId] = useState(0)
  const [subTabId, setSubTabId] = useState(0)
  const [searchValue, setSearchValue] = useState(constData.defaultSearchValue)
  const [headings, setHeadings] = useState(constData.defaultHeadings)
  const [detailHeadings, setDetailHeadings] = useState(constData.defaultDetailHeadings)
  const [programmiDispData, setProgrammiDispData] = useState([])
  const [loading, setLoading] = useState(false)
  const [loadingCountFlag, setLoadingCountFlag] = useState(true)
  const [filterLoading, setFilterLoading] = useState(false)
  const [totalElements, setTotalElements] = useState(0)
  const [filterData, setFilterData] = useState(constData.defaultFilterObject)
  const [multiSearchFlag, setMultiSearchFlag] = useState(false)
  const [displayLimit, setDisplayLimit] = useState(constData.countPerPage)
  const [resultCount, setResultCount] = useState(0)
  const [detailId, setDetailId] = useState([-1,-1])
  const [modalFlag, setModalFlag] = useState(savedProgrammiTab?.modalFlag)
  const [modalData, setModalData] = useState(savedProgrammiTab?.modalData)
  
  const compare = (a, b) => {
    if      (a.checked && !b.checked)   return -1;
    else if (!a.checked && b.checked)   return 1;

    else if (a.count > b.count) return -1;
    else if (a.count < b.count) return 1;

    else if (a.name < b.name)   return -1;
    else if (a.name > b.name)   return 1;

    return 0;
  }
  const sortTempFilterData = (tempData) => {
    tempData[0].data.sort(compare)
    tempData[1].data.sort(compare)
    tempData[2].data.sort(compare)
    return tempData
  }
  const updateFilterObject = (tempProgrammiLine) => {
    let tempData = null;
    tempData = filterData;

    let index = tempData[0].data.findIndex(item=>item.name===tempProgrammiLine.canale)
    if(tempProgrammiLine.canale) index>=0 ? tempData[0].data[index].count++ : tempData[0].data.push({name: tempProgrammiLine.canale, count:1, checked: false})

    index = tempData[1].data.findIndex(item=>item.name===tempProgrammiLine.produzione)
    if(tempProgrammiLine.produzione) index>=0 ? tempData[1].data[index].count++ : tempData[1].data.push({name: tempProgrammiLine.produzione, count:1, checked: false})

    index = tempData[2].data.findIndex(item=>item.name===tempProgrammiLine.genereProduzione)
    if(tempProgrammiLine.genereProduzione) index>=0 ? tempData[2].data[index].count++ : tempData[2].data.push({name: tempProgrammiLine.genereProduzione, count:1, checked: false})

    tempData = sortTempFilterData(tempData)
    setFilterData([...tempData])
  }
  const findProgram = (contents) => {
    contents.forEach(async (item) => {
      const idCanaleMedia = item?.master[0]?.idCanaleMedia
      const idMaster = item?.master[0]?.idMaster
      const idTipologiaSiae = item?.master[0]?.idTipologiaSiae
      const idEnte = item?.master[0]?.idEnteProduttore
      var tempProgrammiLine = {
        utilizzatore: '',
        canale: '',
        produzione: item?.nomeProduzione,
        idProduzione: item?.idProduzione,
        codProduzione: item?.codProduzione,
        edizione: item?.edizione,
        genereProduzione: '',
        produttore: '',
        dataInizio: item?.master[0]?.dtInizio,
        dataFine: item?.master[0]?.dtFine,
        idCanaleMedia: idCanaleMedia,
        idTipologiaSiae: idTipologiaSiae,
        idEnte: idEnte,

        master: item?.master[0]?.descrizione,
        idMaster: item?.master[0]?.idMaster,
        codMaster : item?.master[0]?.codMaster,
        clone: item?.master[0]?.cloni,
        stato: item?.master[0]?.idStatoMaster,
        dtInizio: item?.master[0]?.dtInizio,
        dtFine: item?.master[0]?.dtFine,
        idDetail: item?.master[0]?.detail[0]?.idDetail,
        detail: item?.master[0]?.detail[0]?.descrizione,

        canaleDetail:{
          idCanale : idCanaleMedia,
          canale : '',
          codSintonia : '',
          idUtilizzatore : '',
          utilizzatore : '',
          idEditore : '',
          editore : '',
          tipoMedia : '',
          tolleranza : '',
          offset : '',
          dataInizio : '',
          dataFine : '',
          dataCreazione : '',
          dataModifica : '',
          dataObsolescenza : '',
          note : '',
        },
        utilizzatoreDetail:{
          idUtilizzatore: '',
          utilizzatore: '',
          codUtilizzatore: '',
          note: '',
          idCanale: idCanaleMedia,
          canale: '',
          codSintonia: '',
          idEditore: '',
          editore: '',
          tipoMedia: '',
          dataInizio: '',
          dataFine: '',
        },
        masterDetail:{
          utilizzatore : '',
          canale : '',
          produzione : item?.nomeProduzione,
          idProduzione : item?.idProduzione,
          codProduzione : item?.codProduzione,
          master : item?.master[0]?.descrizione,
          idMaster : item?.master[0]?.idMaster,
          codMaster : item?.master[0]?.codMaster,
          idMasterOriginale : item?.master[0]?.idMasterOriginale,
          numeroEpisodio : item?.master[0]?.numeroEpisodio,
          genereProduzione : item?.master[0]?.tipologiaSiae,
          storageMultimedia : item?.master[0]?.idStorageMultimedia,
          isanEidr : item?.master[0]?.isanEidr,
          produttore : item?.master[0]?.idEnteProduttore,
          clone : item?.master[0]?.cloni,
          tiporeplica : item?.master[0]?.tipoReplica,
          stato : item?.master[0]?.idStatoMaster,
          simulcast : item?.master[0]?.chSimulcast,
          dataInizio : item?.master[0]?.dtInizio,
          dataFine : item?.master[0]?.dtFine,
          dataCreazione : item?.master[0]?.dtCeazione,
          dataModifica : item?.master[0]?.dtModifica,
          dataObsolescenza : item?.master[0]?.dtObsolescenza,
          note : item?.master[0]?.note
        }
      }
      await fetch(baseUrl + '/v1/canalemedia/' + idCanaleMedia, getReqOptions)
      .then((response) => response.text())
      .then((result) => {
        tempProgrammiLine.canale = JSON.parse(result)?.nomeMedia

        tempProgrammiLine.canaleDetail.canale = JSON.parse(result)?.nomeMedia
        tempProgrammiLine.canaleDetail.codSintonia = JSON.parse(result)?.codSintonia
        tempProgrammiLine.canaleDetail.idEditore = JSON.parse(result)?.idEnteEditore
        tempProgrammiLine.canaleDetail.tipoMedia = JSON.parse(result)?.tipoMedia
        tempProgrammiLine.canaleDetail.tolleranza = JSON.parse(result)?.tolleranza
        tempProgrammiLine.canaleDetail.offset = JSON.parse(result)?.offset
        tempProgrammiLine.canaleDetail.dataInizio = JSON.parse(result)?.dtInizioValidita
        tempProgrammiLine.canaleDetail.dataFine = JSON.parse(result)?.dtFineValidita
        tempProgrammiLine.canaleDetail.dataCreazione = JSON.parse(result)?.dtCreazione
        tempProgrammiLine.canaleDetail.dataModifica = JSON.parse(result)?.dtModifica
        tempProgrammiLine.canaleDetail.dataObsolescenza = JSON.parse(result)?.dtObsolescenza
        tempProgrammiLine.canaleDetail.note = JSON.parse(result)?.note

        tempProgrammiLine.utilizzatoreDetail.canale = JSON.parse(result)?.nomeMedia
        tempProgrammiLine.utilizzatoreDetail.codSintonia = JSON.parse(result)?.codSintonia
        tempProgrammiLine.utilizzatoreDetail.idEditore = JSON.parse(result)?.idEnteEditore
        tempProgrammiLine.utilizzatoreDetail.tipoMedia = JSON.parse(result)?.tipoMedia
        tempProgrammiLine.utilizzatoreDetail.dataInizio = JSON.parse(result)?.dtInizioValidita
        tempProgrammiLine.utilizzatoreDetail.dataFine = JSON.parse(result)?.dtFineValidita

        tempProgrammiLine.masterDetail.canale = JSON.parse(result)?.nomeMedia
      })
      .catch((error) => console.log('error', error))
      .finally(async () => {
        await fetch( `${baseUrl}/v1/dettagli/detailMaster?idMaster=${idMaster}`, postReqOptions )
        .then((response) => response.text())
        .then((result) => {
          tempProgrammiLine.utilizzatore = JSON.parse(result)?.content[0]?.idMaster?.idCanaleMedia?.idEnteDistributore?.ragioneSociale
          tempProgrammiLine.masterDetail.utilizzatore = JSON.parse(result)?.content[0]?.idMaster?.idCanaleMedia?.idEnteDistributore?.ragioneSociale
        })
        .catch((error) => console.log('error', error))
        .finally(async () => {
          await fetch( baseUrl + '/v1/tipologiasiae/' + idTipologiaSiae, getReqOptions )
          .then((response) => response.text())
          .then((result) => {
            tempProgrammiLine.genereProduzione = JSON.parse(result)?.descrizione
          })
          .catch((error) => console.log('error', error))
          .finally(async () => {
            await fetch(baseUrl + '/v1/repente/' + idEnte, getReqOptions)
            .then((response) => response.text())
            .then((result) => {
              tempProgrammiLine.produttore = JSON.parse(result)?.ragioneSociale
            })
            .catch((error) => console.log('error', error))
            .finally(() => {
              setProgrammiDispData((programmiDispData) => [
                ...programmiDispData,
                tempProgrammiLine,
              ])
              updateFilterObject(tempProgrammiLine)
            })
          })
        })
      })
    })
  }
  const findProgramByObject = async (searchObj) => {
    setTotalElements(0)
    await fetch(baseUrl + `/v1/programmi/find?page=${1}&size=${1}`, {...postReqOptions, body: JSON.stringify(searchObj)})
    .then((response) => response.text())
    .then(async (result) => {
      if (result){
        let tempTotalElements = JSON.parse(result)?.totalElements
        console.log("-----TotalElements :", tempTotalElements, ", Starting Request Again-----")
        setTotalElements(tempTotalElements)
        if(tempTotalElements){
          await fetch(baseUrl + `/v1/programmi/find?page=${1}&size=${tempTotalElements}`, {...postReqOptions, body: JSON.stringify(searchObj)})
          .then((response) => response.text())
          .then((result) => {
            if (result){
              console.log("----------------Got Primary Result----------------")
              findProgram(JSON.parse(result)?.content)
            }
            else {
              console.log('No Result! :(')
              setProgrammiDispData([])
            }
          })
          .catch((error) =>{
            console.log('error', error)
            setLoading(false)
          })
        }
        else{
          console.log('No Result! :(')
          setLoading(false)
          setFilterLoading(false)
          return;
        }
      }
      else {
        console.log('No Response! :(')
        setProgrammiDispData([])
        setLoading(false)
        setFilterLoading(false)
        return;
      }
    })
    .catch((error) =>{
      console.log('error', error)
      setLoading(false)
    })
  }
  const multiSearch = async () => {
    let flag = false
    searchValue.forEach((item) => {
      let addFlag = item?.value ? true : false
      flag = flag || addFlag
    })
    if (!flag) {
      console.log('Empty Search Value!')
      setLoading(false)
      setFilterLoading(false)
      return
    }
    setMultiSearchFlag(true)
    setFilterData([...constData.defaultFilterObject])
    setDisplayLimit(constData.countPerPage)
    setDetailId([-1 -1])
  }
  const singleSearch = async (index) => {
    if (!searchValue[index].value || !searchValue[index].value?.length) return
    let tempSearchValue = constData.defaultSearchValue //-------defaultSearchValue--------------------------------------------------------------fix
    tempSearchValue[index] = searchValue[index]
    setSearchValue([...tempSearchValue])
    multiSearch()
  }
  const onDragEnd = (fromIndex, toIndex) => {
    let tempHeadings = headings
    const item = tempHeadings[subTabId].splice(fromIndex-1, 1)[0];
    tempHeadings[subTabId].splice(toIndex-1, 0, item);
    setHeadings([...tempHeadings])
  };
  const onDetailDragEnd = (fromIndex, toIndex) => {
    let tempDetailHeadings = detailHeadings
    const item = tempDetailHeadings[subTabId].splice(fromIndex-1, 1)[0];
    tempDetailHeadings[subTabId].splice(toIndex-1, 0, item);
    setDetailHeadings([...tempDetailHeadings])
  };
  
  useEffect(() => {
    let tempObj = savedProgrammiTab[0]
    setSearchValue(tempObj?.searchValue.length? tempObj?.searchValue : constData?.defaultSearchValue)
    setFilterData(tempObj?.filterData)
    setProgrammiDispData(tempObj?.programmiDispData)
    setHeadings(tempObj?.headings[tempObj?.subTabId].length? tempObj?.headings : constData?.defaultHeadings) //--------------------------------------------------------fix
    setDetailHeadings(tempObj?.detailHeadings.length? tempObj?.detailHeadings : constData?.defaultDetailHeadings)//---------------------------------fix
    setDetailId(tempObj?.detailId)
    setTotalElements(tempObj?.totalElements)
    setSubTabId(tempObj?.subTabId)
    setModalFlag(false)
    setModalFlag(tempObj.modalFlag)
    setModalData(tempObj.modalData)
  }, [])
  useEffect(()=>{
    if(!multiSearchFlag) return
    setMultiSearchFlag(false)
    setFilterLoading(true)
    setLoading(true)
    setLoadingCountFlag(true)
    setProgrammiDispData([])
    
    let searchObj = constData.defaultSearchObject
    // searchValue.forEach( async (item, index)=>{
    //   if(!item) return
    //   if (index === 7){}
    //   else if ( index === 0 || index === 1 || index === 2 || index === 6 || index === 8 || index === 9 ){
    //     searchObj = {
    //       ...searchObj,
    //       [constData.filterParaList[index].key]: item,
    //     }
    //   }
    //   else {
    //     let page = 1, size = 100;
    //     await fetch( `${baseUrl}/v1/filtri_programmi/${constData.filterParaList[index].query}${searchValue[index]}&page=${page}&size=${size}`, postReqOptions )
    //     .then((response) => response.text())
    //     .then(async (result) => {
    //       if (result) {
    //         let enter_value = []
    //         for (let i = 0; i < JSON.parse(result).length; i++) 
    //           enter_value.push(JSON.parse(result)[i].id)
    //         searchObj = {
    //           ...searchObj,
    //           [constData.filterParaList[index].key]: enter_value,
    //         }
    //       }
    //     })
    //     .catch((error) => console.log('error', error))
    //   }
    // })
    searchObj.utilizzatore     = searchValue.filter(obj=>(obj.name === 'Utilizzatore'))[0].value
    searchObj.canale           = searchValue.filter(obj=>(obj.name === 'Canale'))[0].value
    searchObj.nomeProduzione   = searchValue.filter(obj=>(obj.name === 'Produzione'))[0].value
    searchObj.idProduzione     = searchValue.filter(obj=>(obj.name === 'ID Produzione'))[0].value.filter(item=>item!==null)
    searchObj.codProduzione    = searchValue.filter(obj=>(obj.name === 'Codice Produzione'))[0].value.filter(item=>item!==null)
    searchObj.idGenereSiae     = searchValue.filter(obj=>(obj.name === 'Genere Produzione'))[0].value    

    searchObj.flagEscludiCloni = searchValue.filter(obj=>(obj.name === 'Escludi Cloni'))[0].value
    searchObj.flagEscludiFilm  = searchValue.filter(obj=>(obj.name === 'Escludi Film'))[0].value
    searchObj.flagSoloFilm     = searchValue.filter(obj=>(obj.name === 'Solo Film'))[0].value

    searchObj.dtFine           = searchValue.filter(obj=>(obj.name === 'Da data'))[0].value
    searchObj.dtInizio         = searchValue.filter(obj=>(obj.name === 'A data'))[0].value

    findProgramByObject(searchObj)
  }, [filterData, multiSearchFlag])
  useEffect(()=>{
    if(totalElements > 0){
      if(programmiDispData.length === totalElements){
        setLoading(false)
        setFilterLoading(false)
        setLoadingCountFlag(false)
      }
      if(programmiDispData.length >= displayLimit){
        setLoading(false)
        setLoadingCountFlag(false)
      }
    }
  },[programmiDispData, totalElements])
  useEffect(()=>{
    let tableCount = 0
    programmiDispData?.forEach((line) => {
      let passFlag = false;

      if(!filterData[0]?.data?.find(item=>item.checked) && !filterData[1]?.data?.find(item=>item.checked) && !filterData[2]?.data?.find(item=>item.checked)) passFlag = true
      if(filterData[0]?.data?.find(item=>item.checked && item.name===line?.canale)) passFlag = true
      if(filterData[1]?.data?.find(item=>item.checked && item.name===line?.produzione)) passFlag = true
      if(filterData[2]?.data?.find(item=>item.checked && item.name===line?.genereProduzione)) passFlag = true

      if(passFlag) tableCount++
    })
    setResultCount(tableCount)
  },[programmiDispData, filterData])
  useEffect(()=>{
    setSavedProgrammiTaB({
      searchValue: searchValue,
      filterData: filterData,
      programmiDispData: programmiDispData,
      headings: headings,
      totalElements: totalElements,
      detailHeadings: detailHeadings,
      detailId: detailId,
      subTabId: subTabId,
      modalFlag: modalFlag,
      modalData: modalData
    }, topTabId)
  },[searchValue, filterData, programmiDispData, totalElements, detailHeadings, detailId, subTabId, modalFlag, modalData])

  return (
    <div className={passFlag ? 'ProgramPage' : 'hidden'}>
      <Header/>
      <div className="middle">
        <LeftBar resultCount={resultCount} displayLimit={displayLimit} searchValue={searchValue} setSearchValue={setSearchValue} constData={constData}
          setProgrammiDispData={setProgrammiDispData} setLoading={setLoading} setFilterLoading={setFilterLoading} singleSearch={singleSearch}
          multiSearch={multiSearch} exitRequestController={exitRequestController} filterLoading={filterLoading} filterData={filterData}
          setFilterData={setFilterData} setDisplayLimit={setDisplayLimit}/>

        {/* <div className="MainBody">
          {!modalFlag ? (<ToolKit />) : (<PopUp modalData={modalData} setModalFlag={setModalFlag}/>)}
          <div className="top-tabs">
            {
              savedProgrammiTab?.map((item,index)=>{
                return(
                  <div className="tab big" key={'toptab-big-'+index}
                    onClick={() => {
                      setSavedProgrammiTaB({
                        searchValue: searchValue,
                        filterData: filterData,
                        programmiDispData: programmiDispData,
                        headings: headings,
                        totalElements: totalElements,
                        detailHeadings: detailHeadings,
                        detailId: detailId,
                        subTabId: subTabId,
                        modalFlag: modalFlag,
                        modalData: modalData
                      }, topTabId)

                      setTopTabId(index)
                      setSubTabId(0)
                      setSearchValue(item?.searchValue)
                      setFilterData(item?.filterData)
                      setProgrammiDispData(item?.programmiDispData)
                      setHeadings(item?.headings)
                      setTotalElements(item?.totalElements)
                      setDetailHeadings(item?.detailHeadings)
                      setDetailId(item?.detailId)
                      setSubTabId(item?.subTabId)
                      setModalFlag(item?.modalFlag)
                      setModalFlag(item?.modalFlag)
                    }}
                  >
                    <p>SEZIONE{index+1}</p>
                    <div className={topTabId === index ? 'underline' : 'hidden'}></div>
                  </div>
                )
              })
            }
          </div>
          <div className="middle-line"></div>
          <div className="top-tabs">
            <div className="tab" onClick={() => setSubTabId(0)}>
              <p>Produzioni</p>
              <div className={subTabId === 0 ? 'underline' : 'hidden'}></div>
            </div>
            <div className="tab" onClick={() => setSubTabId(1)}>
              <p>Master</p>
              <div className={subTabId === 1 ? 'underline' : 'hidden'}></div>
            </div>
            <div className="tab" style={{opacity: '0.3'}}>
              <p>Palinsesto</p>
              <div className={subTabId === 2 ? 'underline' : 'hidden'}></div>
            </div>
          </div>
          <div className="middle-line"></div>
          <div className={!loading ? 'main-table' : 'main-table opacity'}>
            <div className="heading">
              <ReactDragListView.DragColumn
                onDragEnd={onDragEnd}
                nodeSelector='th'
                handleSelector='.dragHandler'
                ignoreSelector='react-resizable-handle'
              >
                <table style={{ width: '100%', paddingRight: '6px' }}>
                  <thead>
                    <tr>
                      <th>
                        <input type="checkbox" defaultChecked={false} />
                      </th>
                      {
                        headings[subTabId]?.map((item, index) => {
                          return (
                            <th key={'MainBodyTableHeading1' + index} className='dragHandler'>{item}</th>
                          )
                        })
                      }
                      <th>
                        {' '}<SaveIcon onClick={()=>{
                          if(searchValue.filter((value) => value !== '').length === 0){ alert('No search value'); return; }
                          if(totalElements === 0){ alert('No search result'); return; }
                          if(programmiDispData.length < totalElements){ alert('Search is not finished'); return; }
                          setSavedProgrammiTaB({
                            searchValue: searchValue,
                            filterData: filterData,
                            programmiDispData: programmiDispData,
                            headings: headings,
                            totalElements: totalElements,
                            detailHeadings: detailHeadings,
                            detailId: detailId,
                            subTabId: subTabId,
                            modalFlag: modalFlag,
                            modalData: modalData
                          }, topTabId)
                          setSavedProgrammiTaB({
                            searchValue: [],
                            filterData: [],
                            programmiDispData: [],
                            headings: constData?.defaultHeadings,
                            totalElements: 0,
                            detailHeadings: constData?.defaultDetailHeadings,
                            detailId: [-1 -1],
                            subTabId: 0,
                            modalFlag: false,
                            modalData: {}
                          }, savedProgrammiTab?.length)

                          setTopTabId(savedProgrammiTab?.length)
                          setSubTabId(0)
                          setSearchValue(constData.defaultSearchValue)
                          setFilterData([])
                          setProgrammiDispData([])
                          setHeadings(constData?.defaultHeadings)
                          setTotalElements(0)
                          setDetailHeadings(constData?.defaultDetailHeadings)
                          setDetailId([-1, -1])
                          setSubTabId(0)
                          setModalFlag(false)
                          setModalData({})
                        }}/>{' '}
                      </th>
                    </tr>
                  </thead>
                  <tbody style={{pointerEvents:'none'}}>
                    {
                      programmiDispData?.map((line, lineIndex) => {
                        if(lineIndex === 0) tableCount1 = 0
                        let passFlag = false;

                        if(!filterData[0]?.data?.find(item=>item.checked) && !filterData[1]?.data?.find(item=>item.checked) && !filterData[2]?.data?.find(item=>item.checked)) passFlag = true
                        if(filterData[0]?.data?.find(item=>item.checked && item.name===line?.canale)) passFlag = true
                        if(filterData[1]?.data?.find(item=>item.checked && item.name===line?.produzione)) passFlag = true
                        if(filterData[2]?.data?.find(item=>item.checked && item.name===line?.genereProduzione)) passFlag = true

                        if(passFlag && tableCount1 < displayLimit){
                          tableCount1++;
                          return (
                            <>
                              <tr key={'MainBodyTableLine' + lineIndex}>
                                <td>
                                  <input type="checkbox" defaultChecked={false} />
                                </td>
                                {
                                  headings[subTabId]?.map((title)=>{
                                    switch (title) {
                                      case 'Utilizzatore':      
                                        return <td style={line?.utilizzatore?{cursor:'pointer'}:{cursor:'pointer',color:'lightgrey'}}><u>{line?.utilizzatore || 'null'}</u></td>
                                      case 'Canale':            
                                        return <td style={line?.canale?{cursor:'pointer'}:{cursor:'pointer',color:'lightgrey'}}><u>{line?.canale || 'null'}</u></td>
                                      case 'Produzione':        
                                        return <td style={line?.produzione?{cursor:'pointer'}:{cursor:'pointer',color:'lightgrey'}}><u>{line?.produzione || 'null'}</u></td>
                                      case 'ID Produzione':     
                                        return <td style={line?.idProduzione?{}:{color:'lightgrey'}}>{line?.idProduzione || 'null'}</td>
                                      case 'Codice Produzione': 
                                        return <td style={line?.codProduzione?{}:{color:'lightgrey'}}>{line?.codProduzione || 'null'}</td>
                                      case 'Edizione':          
                                        return <td style={line?.edizione?{}:{color:'lightgrey'}}>{line?.edizione || 'null'}</td>
                                      case 'Genere Produzione': 
                                        return <td style={line?.genereProduzione?{cursor:'pointer'}:{cursor:'pointer',color:'lightgrey'}}><u>{line?.genereProduzione || 'null'}</u></td>
                                      case 'Produttore':        
                                        return <td style={line?.produttore?{}:{color:'lightgrey'}}>{line?.produttore || 'null'}</td>
                                      case 'Data Inizio':       
                                        return <td style={line?.dataInizio?{}:{color:'lightgrey'}}>{line?.dataInizio || 'null'}</td>
                                      case 'Data Fine':         
                                        return <td style={line?.dataFine?{}:{color:'lightgrey'}}>{line?.dataFine || 'null'}</td>
                                      
                                      case 'Master':            
                                        return <td style={line?.genereProduzione?{cursor:'pointer'}:{cursor:'pointer',color:'lightgrey'}}><u>{line?.master || 'null'}</u></td>
                                      case 'Id Master':         
                                        return <td style={line?.idMaster?{}:{color:'lightgrey'}}>{line?.idMaster  || 'null'}</td>
                                      case 'Codice Master':     
                                        return <td style={line?.codMaster?{}:{color:'lightgrey'}}>{line?.codMaster || 'null'}</td>
                                      case 'Clone':             
                                        return <td style={line?.clone?{}:{color:'lightgrey'}}>{line?.clone || 'null'}</td>
                                      case 'Stato':             
                                        return <td style={line?.stato?{}:{color:'lightgrey'}}>{line?.stato || 'null'}</td>

                                      default:                  
                                        return <></>
                                    }
                                  })
                                }
                                <td>
                                  {' '}<RightwardIcon className={ detailId[subTabId] === lineIndex ? "rotate-anti-clockwise" : "rotate-clockwise" }
                                  onClick={()=> {
                                    let tempDetailId = detailId
                                    tempDetailId[subTabId] = detailId[subTabId] === lineIndex ? -1 : lineIndex
                                    setDetailId([...tempDetailId]) 
                                  }} style={{marginRight: '15px'}}/>{' '}
                                </td>
                              </tr>
                              <tr className={ detailId[subTabId] === lineIndex ? "detail-table" : "hidden" }>
                                <th> <input type="checkbox" defaultChecked={false} /> </th>
                                {
                                  detailHeadings[subTabId]?.map((iitem, iindex) => {
                                    return (
                                      <th key={'detail-table-header-' + iindex} className='dragHandler'>{iitem}</th>
                                    )
                                  })
                                }
                              </tr>
                              <tr className={ detailId[subTabId] === lineIndex ? "detail-table" : "hidden" }>
                                <td> <input type="checkbox" defaultChecked={false} /> </td>
                                {
                                  detailHeadings[subTabId]?.map((iitem) => {
                                    switch(iitem){
                                      case 'Master':            
                                        return <td><u>{line?.master || 'null'}</u></td>
                                      case 'Id Master': 
                                        return <td>{line?.idMaster || 'null'}</td>
                                      case 'Cod Master': 
                                        return <td>{line?.codMaster || 'null'}</td>
                                      case 'Clone': 
                                        return <td>{line?.clone || 'null'}</td>
                                      case 'Stato': 
                                        return <td>{line?.stato || 'null'}</td>
                                      case 'Data Inizio': 
                                        return <td>{line?.dtInizio || 'null'}</td>
                                      case 'Data Fine': 
                                        return <td>{line?.dtFine || 'null'}</td>

                                      case 'ID Detail': 
                                        return <td>{line?.idDetail || 'null'}</td>
                                      case 'Detail': 
                                        return <td>{line?.detail || 'null'}</td>
                                      default: 
                                        return <></>
                                    }
                                  })
                                }
                              </tr>
                            </>
                          )
                        }
                        else return <></>
                      })
                    }
                  </tbody>
                </table>
              </ReactDragListView.DragColumn>
            </div>
            <div className={resultCount > displayLimit ? 'scroll show-show-more' : 'scroll'}>
              <ReactDragListView.DragColumn
                onDragEnd={onDetailDragEnd}
                nodeSelector='th'
                handleSelector='.dragHandler'
                ignoreSelector='react-resizable-handle'
              >
                <table style={{ width: '100%' }}>
                  <thead>
                    <tr style={{ opacity: '0' }}>
                      <th>
                        <input type="checkbox" defaultChecked={false} />
                      </th>
                      {
                        headings[subTabId]?.map((item, index) => {
                          return (
                            <th key={'MainBodyTableHeading1' + index} className='dragHandler'>{item}</th>
                          )
                        })
                      }
                      <th>{' '}<SaveIcon />{' '}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {programmiDispData?.map((line, lineIndex) => {
                      if(lineIndex === 0) tableCount2 = 0
                      let passFlag = false;

                      if(!filterData[0]?.data?.find(item=>item.checked) && !filterData[1]?.data?.find(item=>item.checked) && !filterData[2]?.data?.find(item=>item.checked)) passFlag = true
                      if(filterData[0]?.data?.find(item=>item.checked && item.name===line?.canale)) passFlag = true
                      if(filterData[1]?.data?.find(item=>item.checked && item.name===line?.produzione)) passFlag = true
                      if(filterData[2]?.data?.find(item=>item.checked && item.name===line?.genereProduzione)) passFlag = true

                      if(passFlag && tableCount2 < displayLimit){
                        let tempLine = line;
                        tableCount2++
                        return (
                          <>
                            <tr key={'MainBodyTableLine' + lineIndex}>
                              <td>
                                <input type="checkbox" defaultChecked={false} />
                              </td>
                              {
                                headings[subTabId]?.map((title)=>{
                                  switch (title) {
                                    case 'Utilizzatore':      
                                      return <td onClick={ async () => {
                                        setLoading(true);
                                        let tempModalData = {title : "Dettaglio Utilizzatore"}
                                        await fetch(baseUrl + `/v1/canalemedia/${tempLine?.utilizzatoreDetail?.idCanale}/idEnteDistributore`, getReqOptions)
                                        .then((response) => response.text())
                                        .then((result) => {
                                          tempLine.utilizzatoreDetail.idUtilizzatore = JSON.parse(result)?.idEnte
                                        })
                                        .catch((err)=>console.log(err))
                                        .finally(async () => {
                                          await fetch(baseUrl + `/v1/repente/${tempLine?.utilizzatoreDetail?.idUtilizzatore}`, getReqOptions)
                                          .then((response) => response.text())
                                          .then((result) => {
                                            tempLine.utilizzatoreDetail.utilizzatore = JSON.parse(result)?.ragioneSociale
                                            tempLine.utilizzatoreDetail.codUtilizzatore = JSON.parse(result)?.codEntegespro
                                            tempLine.utilizzatoreDetail.note = JSON.parse(result)?.note
                                          })
                                          .catch((err)=>console.log(err))
                                          .finally(async () => {
                                            await fetch(baseUrl + '/v1/repente/' + tempLine?.utilizzatoreDetail?.idEditore, getReqOptions)
                                            .then((response) => response.text())
                                            .then((result) => {
                                              tempLine.utilizzatoreDetail.editore = JSON.parse(result)?.ragioneSociale
                                            })
                                            .catch((error) => console.log('error', error))
                                            .finally(()=>{
                                              tempModalData = {
                                                ...tempModalData,
                                                detail: [
                                                  { key : "Id Utilizzatore",   value : tempLine?.utilizzatoreDetail?.idUtilizzatore },
                                                  { key : "Utilizzatore",      value : tempLine?.utilizzatoreDetail?.utilizzatore },
                                                  { key : "Cod Utilizzatore",  value : tempLine?.utilizzatoreDetail?.codUtilizzatore },
                                                  { key : "Note",              value : tempLine?.utilizzatoreDetail?.note },
                                                ],
                                                additional: [
                                                  { key : "Id Canale",         value : tempLine?.utilizzatoreDetail?.idCanale },
                                                  { key : "Canale",            value : tempLine?.utilizzatoreDetail?.canale },
                                                  { key : "Cod Sintonia",      value : tempLine?.utilizzatoreDetail?.codSintonia },
                                                  { key : "Id Editore",        value : tempLine?.utilizzatoreDetail?.idEditore },
                                                  { key : "Editore",           value : tempLine?.utilizzatoreDetail?.editore },
                                                  { key : "Tipo Media",        value : tempLine?.utilizzatoreDetail?.tipoMedia },
                                                  { key : "Data Inizio",       value : tempLine?.utilizzatoreDetail?.dataInizio },
                                                  { key : "Data Fine",         value : tempLine?.utilizzatoreDetail?.dataFine }
                                                ]
                                              }
                                            })
                                          })
                                        })
                                        setModalData({...tempModalData})
                                        setModalFlag(true)
                                        setLoading(false);
                                      }}
                                      style={line?.utilizzatore?{cursor:'pointer'}:{cursor:'pointer',color:'lightgrey'}}><u>{line?.utilizzatore || 'null'}</u></td>
                                    case 'Canale':            
                                      return <td onClick={ async () => {
                                        setLoading(true);
                                        let tempModalData = {title : "Dettaglio Canale"}
                                        await fetch(baseUrl + '/v1/canalemedia/' + tempLine?.canaleDetail?.idCanale + '/idEnteDistributore', getReqOptions)
                                        .then((response) => response.text())
                                        .then((result) => {
                                          tempLine.canaleDetail.idUtilizzatore = JSON.parse(result)?.idEnte
                                        })
                                        .catch((error) => console.log('error', error))
                                        .finally(async()=>{
                                          await fetch(baseUrl + '/v1/repente/' + tempLine?.canaleDetail?.idUtilizzatore, getReqOptions)
                                          .then((response) => response.text())
                                          .then((result) => {
                                            tempLine.canaleDetail.utilizzatore = JSON.parse(result)?.ragioneSociale
                                          })
                                          .catch((error) => console.log('error', error))
                                          .finally(async()=>{
                                            await fetch(baseUrl + '/v1/repente/' + tempLine?.canaleDetail?.idEditore, getReqOptions)
                                            .then((response) => response.text())
                                            .then((result) => {
                                              tempLine.canaleDetail.editore = JSON.parse(result)?.ragioneSociale
                                            })
                                            .catch((error) => console.log('error', error))
                                            .finally(()=>{
                                              tempModalData = {
                                                ...tempModalData,
                                                detail: [
                                                  { key : "Id Canale",         value : tempLine?.canaleDetail?.idCanale },
                                                  { key : "Canale",            value : tempLine?.canaleDetail?.canale },
                                                  { key : "Cod Sintonia",      value : tempLine?.canaleDetail?.codSintonia },
                                                  { key : "Id Utilizzatore",   value : tempLine?.canaleDetail?.idUtilizzatore },
                                                  { key : "Utilizzatore",      value : tempLine?.canaleDetail?.utilizzatore },
                                                  { key : "Id Editore",        value : tempLine?.canaleDetail?.idEditore },
                                                  { key : "Editore",           value : tempLine?.canaleDetail?.editore },
                                                  { key : "Tipo Media",        value : tempLine?.canaleDetail?.tipoMedia },
                                                  { key : "Tolleranza",        value : tempLine?.canaleDetail?.tolleranza },
                                                  { key : "Offset",            value : tempLine?.canaleDetail?.offset },
                                                  { key : "Data Inizio",       value : tempLine?.canaleDetail?.dataInizio },
                                                  { key : "Data Fine",         value : tempLine?.canaleDetail?.dataFine },
                                                  { key : "Data Creazione",    value : tempLine?.canaleDetail?.dataCreazione },
                                                  { key : "Data Modifica",     value : tempLine?.canaleDetail?.dataModifica },
                                                  { key : "Data Obsolescenza", value : tempLine?.canaleDetail?.dataObsolescenza },
                                                  { key : "Note",              value : tempLine?.canaleDetail?.note }
                                                ]
                                              }
                                            })
                                          })
                                        })
                                        setModalData({...tempModalData})
                                        setModalFlag(true)
                                        setLoading(false);
                                      }}
                                      style={line?.canale?{cursor:'pointer'}:{cursor:'pointer',color:'lightgrey'}}><u>{line?.canale || 'null'}</u></td>
                                    case 'Produzione':        
                                      return <td onClick={ async () => {
                                        setLoading(true);
                                        let tempModalData = {title : "Dettaglio Produzione"}
                                        let obj;
                                        await fetch(baseUrl + `/v1/produzione/${line?.idProduzione}`, getReqOptions)
                                        .then((response) => response.text())
                                        .then((result) => {
                                          if (result) {
                                            obj = JSON.parse(result)
                                            tempModalData = {
                                              ...tempModalData,
                                              detail: [
                                                { key : "Id Produzione", value : obj?.idProduzione },
                                                { key : "Produzione", value : obj?.nomeProduzione },
                                                { key : "Cod Produzione", value : obj?.codProduzione },
                                              ]
                                            }
                                          } else {
                                            console.log('No Result! :(')
                                          }
                                        })
                                        .then(async ()=>{
                                          await fetch(baseUrl + `/v1/produzione/${line?.idProduzione}/idProduzioneMadre`, getReqOptions)
                                          .then((response) => response.text())
                                          .then((result) => {
                                            let deepObj = JSON.parse(result)
                                            tempModalData = {
                                              ...tempModalData,
                                              detail: [
                                                ...tempModalData.detail,
                                                { key : "Madre", value : deepObj?.idProduzione },
                                                { key : "Produzione Originale", value : null },
        
                                                { key : "Area", value : obj?.idArea },
                                                { key : "Edizione", value : obj?.edizione },
                                                { key : "ISAN/EIDR", value : obj?.isanEidr },
                                                { key : "Data Inizio", value : obj?.dtInizio },
                                                { key : "Data Fine", value : obj?.dtFine },
                                                { key : "Data Creazione", value : obj?.dtCreazione },
                                                { key : "Data Modifica", value : obj?.dtModifica },
                                                { key : "Data Obsolescenza", value : obj?.dtObsolescenza },
                                                { key : "Note", value : obj?.note },
                                              ]
                                            }
                                          })
                                          .catch((err)=>console.log(err))
                                        })
                                        .catch((err)=>console.log(err))
                                        setModalData({...tempModalData})
                                        setModalFlag(true)
                                        setLoading(false);
                                      }}
                                      style={line?.produzione?{cursor:'pointer'}:{cursor:'pointer',color:'lightgrey'}}><u>{line?.produzione || 'null'}</u></td>
                                    case 'ID Produzione':     
                                      return <td style={line?.idProduzione?{}:{color:'lightgrey'}}>{line?.idProduzione || 'null'}</td>
                                    case 'Codice Produzione': 
                                      return <td style={line?.codProduzione?{}:{color:'lightgrey'}}>{line?.codProduzione || 'null'}</td>
                                    case 'Edizione':          
                                      return <td style={line?.edizione?{}:{color:'lightgrey'}}>{line?.edizione || 'null'}</td>
                                    case 'Genere Produzione': 
                                      return <td onClick={ async () => {
                                        setLoading(true);
                                        let tempModalData = {title : "Dettaglio Genere Produzione (Tipologia SIAE)"}
                                        let obj;
                                        await fetch(baseUrl + `/v1/tipologiasiae/${line?.idTipologiaSiae}`, getReqOptions)
                                        .then((response) => response.text())
                                        .then((result) => {
                                          if (result) {
                                            obj = JSON.parse(result)
                                            tempModalData = {
                                              ...tempModalData,
                                              detail: [
                                                { key : "Id Genere Produzione", value : obj?.idTipologiaProduzione },
                                                { key : "Genere Produzione", value : obj?.descrizione },
                                                { key : "Tipo", value : obj?.tipo },
                                                { key : "Sottotipo", value : obj?.sottotipo },
                                                { key : "Cod Genere Produzione", value : obj?.codTipologiaSiae },
                                                { key : "Cliente", value : obj?.idCliente },
                                                { key : "Opera Filmica", value : null },
                                                { key : "Data Inizio", value : obj?.dtInizio },
                                                { key : "Data Fine", value : obj?.dtFine },
                                                { key : "Data Creazione", value : obj?.dtCreazione },
                                                { key : "Data Modifica", value : obj?.dtModifica },
                                                { key : "Data Obsolescenza", value : obj?.dtObsolescenza },
                                                { key : "Note", value : obj?.note },
                                              ]
                                            }
                                          } else {
                                            console.log('No Result! :(')
                                          }
                                        })
                                        .catch((err)=>console.log(err))
                                        setModalData({...tempModalData})
                                        setModalFlag(true)
                                        setLoading(false);
                                      }}
                                      style={line?.genereProduzione?{cursor:'pointer'}:{cursor:'pointer',color:'lightgrey'}}><u>{line?.genereProduzione || 'null'}</u></td>
                                    case 'Produttore':        
                                      return <td style={line?.produttore?{}:{color:'lightgrey'}}>{line?.produttore || 'null'}</td>
                                    case 'Data Inizio':       
                                      return <td style={line?.dataInizio?{}:{color:'lightgrey'}}>{line?.dataInizio || 'null'}</td>
                                    case 'Data Fine':         
                                      return <td style={line?.dataFine?{}:{color:'lightgrey'}}>{line?.dataFine || 'null'}</td>
                                    
                                    case 'Master':            
                                      return <td onClick={ async () => {
                                        setLoading(true);
                                        let tempModalData = {title : "Dettaglio Master"}
                                        tempModalData = {
                                          ...tempModalData,
                                          detail: [
                                            { key : "Utilizzatore",        value : tempLine?.masterDetail?.utilizzatore },
                                            { key : "Canale",              value : tempLine?.masterDetail?.canale },
                                            { key : "Produzione",          value : tempLine?.masterDetail?.produzione },
                                            { key : "Id Produzione",       value : tempLine?.masterDetail?.idProduzione },
                                            { key : "Cod Produzione",      value : tempLine?.masterDetail?.codProduzione },
                                            { key : "Master",              value : tempLine?.masterDetail?.master },
                                            { key : "Id Master",           value : tempLine?.masterDetail?.idMaster },
                                            { key : "Cod Master",          value : tempLine?.masterDetail?.codMaster },
                                            { key : "Id Master Originale", value : tempLine?.masterDetail?.idMasterOriginale },
                                            { key : "Numero Episodio",     value : tempLine?.masterDetail?.numeroEpisodio },
                                            { key : "Genere Produzione",   value : tempLine?.masterDetail?.genereProduzione },
                                            { key : "Storage Multimedia",  value : tempLine?.masterDetail?.storageMultimedia },
                                            { key : "ISAN/EIDR",           value : tempLine?.masterDetail?.isanEidr },
                                            { key : "Produttore",          value : tempLine?.masterDetail?.produttore },
                                            { key : "Clone",               value : tempLine?.masterDetail?.clone },
                                            { key : "Tipo replica",        value : tempLine?.masterDetail?.tiporeplica },
                                            { key : "Stato",               value : tempLine?.masterDetail?.stato },
                                            { key : "Simulcast",           value : tempLine?.masterDetail?.simulcast },
                                            { key : "Data Inizio",         value : tempLine?.masterDetail?.dataInizio },
                                            { key : "Data Fine",           value : tempLine?.masterDetail?.dataFine },
                                            { key : "Data Creazione",      value : tempLine?.masterDetail?.dataCreazione },
                                            { key : "Data Modifica",       value : tempLine?.masterDetail?.dataModifica },
                                            { key : "Data Obsolescenza",   value : tempLine?.masterDetail?.dataObsolescenza },
                                            { key : "Note",                value : tempLine?.masterDetail?.note }
                                          ]
                                        }
                                        setModalData({...tempModalData})
                                        setModalFlag(true)
                                        setLoading(false);
                                      }} style={line?.genereProduzione?{cursor:'pointer'}:{cursor:'pointer',color:'lightgrey'}}><u>{line?.master || 'null'}</u></td>
                                    case 'Id Master':         
                                      return <td style={line?.idMaster?{}:{color:'lightgrey'}}>{line?.idMaster  || 'null'}</td>
                                    case 'Codice Master':     
                                      return <td style={line?.codMaster?{}:{color:'lightgrey'}}>{line?.codMaster || 'null'}</td>
                                    case 'Clone':             
                                      return <td style={line?.clone?{}:{color:'lightgrey'}}>{line?.clone || 'null'}</td>
                                    case 'Stato':             
                                      return <td style={line?.stato?{}:{color:'lightgrey'}}>{line?.stato || 'null'}</td>

                                    default:                  
                                      return <></>
                                  }
                                })
                              }
                              <td>
                                {' '}<RightwardIcon className={ detailId[subTabId] === lineIndex ? "rotate-anti-clockwise" : "rotate-clockwise" }
                                onClick={()=> {
                                  let tempDetailId = detailId
                                  tempDetailId[subTabId] = detailId[subTabId] === lineIndex ? -1 : lineIndex
                                  setDetailId([...tempDetailId]) 
                                }} style={{marginRight: '15px'}}/>{' '}
                              </td>
                            </tr>
                            <tr className={ detailId[subTabId] === lineIndex ? "detail-table" : "hidden" }>
                              <th> <input type="checkbox" defaultChecked={false} /> </th>
                              {
                                detailHeadings[subTabId]?.map((iitem, iindex) => {
                                  return (
                                    <th key={'detail-table-header-' + iindex} className='dragHandler'>{iitem}</th>
                                  )
                                })
                              }
                            </tr>
                            <tr className={ detailId[subTabId] === lineIndex ? "detail-table" : "hidden" }>
                              <td> <input type="checkbox" defaultChecked={false} /> </td>
                              {
                                detailHeadings[subTabId]?.map((iitem) => {
                                  switch(iitem){
                                    case 'Master':            
                                      return <td onClick={ async () => {
                                        setLoading(true);
                                        let tempModalData = {title : "Dettaglio Master"}
                                        tempModalData = {
                                          ...tempModalData,
                                          detail: [
                                            { key : "Utilizzatore",        value : tempLine?.masterDetail?.utilizzatore },
                                            { key : "Canale",              value : tempLine?.masterDetail?.canale },
                                            { key : "Produzione",          value : tempLine?.masterDetail?.produzione },
                                            { key : "Id Produzione",       value : tempLine?.masterDetail?.idProduzione },
                                            { key : "Cod Produzione",      value : tempLine?.masterDetail?.codProduzione },
                                            { key : "Master",              value : tempLine?.masterDetail?.master },
                                            { key : "Id Master",           value : tempLine?.masterDetail?.idMaster },
                                            { key : "Cod Master",          value : tempLine?.masterDetail?.codMaster },
                                            { key : "Id Master Originale", value : tempLine?.masterDetail?.idMasterOriginale },
                                            { key : "Numero Episodio",     value : tempLine?.masterDetail?.numeroEpisodio },
                                            { key : "Genere Produzione",   value : tempLine?.masterDetail?.genereProduzione },
                                            { key : "Storage Multimedia",  value : tempLine?.masterDetail?.storageMultimedia },
                                            { key : "ISAN/EIDR",           value : tempLine?.masterDetail?.isanEidr },
                                            { key : "Produttore",          value : tempLine?.masterDetail?.produttore },
                                            { key : "Clone",               value : tempLine?.masterDetail?.clone },
                                            { key : "Tipo replica",        value : tempLine?.masterDetail?.tiporeplica },
                                            { key : "Stato",               value : tempLine?.masterDetail?.stato },
                                            { key : "Simulcast",           value : tempLine?.masterDetail?.simulcast },
                                            { key : "Data Inizio",         value : tempLine?.masterDetail?.dataInizio },
                                            { key : "Data Fine",           value : tempLine?.masterDetail?.dataFine },
                                            { key : "Data Creazione",      value : tempLine?.masterDetail?.dataCreazione },
                                            { key : "Data Modifica",       value : tempLine?.masterDetail?.dataModifica },
                                            { key : "Data Obsolescenza",   value : tempLine?.masterDetail?.dataObsolescenza },
                                            { key : "Note",                value : tempLine?.masterDetail?.note }
                                          ]
                                        }
                                        setModalData({...tempModalData})
                                        setModalFlag(true)
                                        setLoading(false);
                                      }} style={line?.master?{cursor:'pointer'}:{cursor:'pointer',color:'lightgrey'}}><u>{line?.master || 'null'}</u></td>
                                    case 'Id Master': 
                                      return <td style={line?.idMaster?{}:{color:'lightgrey'}}>{line?.idMaster || 'null'}</td>
                                    case 'Cod Master': 
                                      return <td style={line?.codMaster?{}:{color:'lightgrey'}}>{line?.codMaster || 'null'}</td>
                                    case 'Clone': 
                                      return <td style={line?.clone?{}:{color:'lightgrey'}}>{line?.clone || 'null'}</td>
                                    case 'Stato': 
                                      return <td style={line?.stato?{}:{color:'lightgrey'}}>{line?.stato || 'null'}</td>
                                    case 'Data Inizio': 
                                      return <td style={line?.dtInizio?{}:{color:'lightgrey'}}>{line?.dtInizio || 'null'}</td>
                                    case 'Data Fine': 
                                      return <td style={line?.dtFine?{}:{color:'lightgrey'}}>{line?.dtFine || 'null'}</td>

                                    case 'ID Detail': 
                                      return <td style={line?.idDetail?{}:{color:'lightgrey'}}>{line?.idDetail || 'null'}</td>
                                    case 'Detail': 
                                      return <td style={line?.detail?{}:{color:'lightgrey'}}>{line?.detail || 'null'}</td>
                                    default: 
                                      return <></>
                                  }
                                })
                              }
                            </tr>
                          </>
                        )
                      }
                      else return<></>
                    })}
                  </tbody>
                </table>
              </ReactDragListView.DragColumn>
            </div>
            <div className={resultCount > displayLimit ? 'show-more' : 'hidden'} onClick={()=>setDisplayLimit(displayLimit + constData.countPerPage)}>Load More...</div>
          </div>
          <div className={loading ? 'loading-container' : 'hidden'}>
            <div className={totalElements > 0 && loadingCountFlag ? 'center-count' : 'hidden'}>{programmiDispData.length}/{totalElements}</div>
          </div>
        </div> */}
        <MainBody modalData={modalData} setModalData={setModalData} modalFlag={modalFlag} setModalFlag={setModalFlag} resultCount={resultCount} subTabId={subTabId}
          setSubTabId={setSubTabId} detailHeadings={detailHeadings} detailId={detailId} setDetailId={setDetailId} getReqOptions={getReqOptions} baseUrl={baseUrl}
          setDisplayLimit={setDisplayLimit} displayLimit={displayLimit} constData={constData} loading={loading} setLoading={setLoading} loadingCountFlag={loadingCountFlag}
          programmiDispData={programmiDispData} totalElements={totalElements} setTotalElements={setTotalElements} headings={headings} setHeadings={setHeadings}
          filterData={filterData} setFilterData={setFilterData} setProgrammiDispData={setProgrammiDispData} searchValue={searchValue} setSearchValue={setSearchValue}
          savedProgrammiTab={savedProgrammiTab} setSavedProgrammiTaB={setSavedProgrammiTaB} topTabId={topTabId} setTopTabId={setTopTabId}
          onDragEnd={onDragEnd} onDetailDragEnd={onDetailDragEnd} setDetailHeadings={setDetailHeadings}/>
        <RightBar />
      </div>
      <Footer />
    </div>
  )
}

export default ProgramPage
